import {
  FlexComp,
  ShimmerVersion2,
  TextNodeType,
} from "@tm/ui-widgets/components";
import {
  TravelDateWigetShimmerStyle,
  TravellerCountWigetShimmerStyle,
  TravellingToWidgetStyle,
} from "./TravellingToWidget.style";

interface TravellingToWidgetProps {
  travelPurposeTxt?: string;
  travCountTitle?: TextNodeType | string;
  travPurpTitle?: string;
  travDateTitle?: string;
  btnDisabledState?: boolean;
}

const TravellingToWidgetShimmer = ({}: TravellingToWidgetProps) => {
  return (
    <TravellingToWidgetStyle>
      <TravelDateWigetShimmerStyle>
        <FlexComp flexDirection="column" gap="4px">
          <ShimmerVersion2 width="76px" height="16px" />
          <ShimmerVersion2 width="76px" height="38px" />
        </FlexComp>
        <ShimmerVersion2 width="76px" height="38px" />
      </TravelDateWigetShimmerStyle>
      <TravellerCountWigetShimmerStyle>
        <FlexComp flexDirection="column" gap="4px">
          <ShimmerVersion2 width="76px" height="16px" />
          <ShimmerVersion2 width="76px" height="38px" />
        </FlexComp>
        <ShimmerVersion2 width="76px" height="38px" />
      </TravellerCountWigetShimmerStyle>
    </TravellingToWidgetStyle>
  );
};

export default TravellingToWidgetShimmer;
